






























































import http from '@/utils/http'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
})
export default class App extends Vue {

  private starting = true

  get isLoggedIn(): boolean {
    return this.$store.state.user.token ? true : false
  }

  get token(): string {
    return this.$store.state.user.token || ''
  }

  private redirectLogin() {
    if (!this.$route) {
      return
    }
    if (this.$route.name === 'login') {
      return
    }
    if (this.$route.name === 'signup') {
      return
    }
    if (this.$route.name === 'forgot') {
      return
    }
    if (this.$route.name === 'forgot-change') {
      return
    }
    this.$router.push('login')
  }

  @Watch('isLoggedIn') // { immediate: true }
  private onIsLoggedIn(value: any) {
    if (!value) {
      this.redirectLogin()
    }
  }

  @Watch('$route') // { immediate: true }
  private onRoute(value: any) {
    if (this && !this.isLoggedIn) {
      this.redirectLogin()
    }
  }

  private mounted() {
    const callback = () => {
      if (!this.isLoggedIn) {
        this.redirectLogin()
      }
      this.starting = false
    }
    let token = ''
    try {
      token = localStorage.getItem('gigportaltoken') || ''
    } catch (e) {
      // tslint:disable:no-console
      console.error('warning: could not load token from localstorage')
    }
    if (token) {
      http.post('/auth/verify', {token})
        .then((response: any) => {
          if (response && response.data && response.data.isValid) {
            this.$store.commit('userLoggedIn', {
              email: response.data.email,
              token
            })
          }
          callback()
        })
        .catch((err: any) => {
          callback()
        })
    } else {
      callback()
    }
  }

}

